import React from "react";
import { Modal, Form, Input, Select, Row, Col, Space, Alert } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { PREFIX_OPTIONS, RELATION_OPTIONS, NATION_OPTIONS } from "../constants";

const AddDefendantModal = ({
  open,
  onCancel,
  onOk,
  form,
  loading,
  nextGarno,
  guarantorsLength,
}) => {
  const defendantNumber = (guarantorsLength || 0) + 2;

  return (
    <Modal
      title={
        <Space>
          <UserAddOutlined style={{ color: "#1890ff" }} />
          <span>เพิ่มจำเลย (จำเลยที่ {defendantNumber})</span>
        </Space>
      }
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText="เพิ่มจำเลย"
      cancelText="ยกเลิก"
      width={700}
      destroyOnHidden
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          prefix: "นาย",
          nation: "ไทย",
        }}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="คำนำหน้า"
              name="prefix"
              rules={[{ required: true, message: "กรุณาเลือกคำนำหน้า" }]}
            >
              <Select size="large" options={PREFIX_OPTIONS} />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              label="ชื่อ"
              name="firstName"
              rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
            >
              <Input size="large" placeholder="กรอกชื่อ" />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              label="นามสกุล"
              name="lastName"
              rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
            >
              <Input size="large" placeholder="กรอกนามสกุล" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="เลขบัตรประชาชน"
              name="idCard"
              rules={[
                { required: true, message: "กรุณากรอกเลขบัตรประชาชน" },
                { len: 13, message: "เลขบัตรประชาชนต้องมี 13 หลัก" },
                { pattern: /^[0-9]+$/, message: "กรุณากรอกเฉพาะตัวเลข" },
              ]}
            >
              <Input
                size="large"
                placeholder="กรอกเลขบัตรประชาชน"
                maxLength={13}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="ความสัมพันธ์"
              name="relation"
              rules={[{ required: true, message: "กรุณาเลือกความสัมพันธ์" }]}
            >
              <Select
                size="large"
                placeholder="เลือกความสัมพันธ์"
                allowClear
                options={RELATION_OPTIONS}
              />
            </Form.Item>
          </Col>
        </Row>
        <Alert
          message={`จะเพิ่มเป็นผู้ค้ำลำดับที่ ${nextGarno} (จำเลยที่ ${defendantNumber})`}
          description="ข้อมูลจะถูกบันทึกลงระบบและแสดงในรายการเลือกจำเลยทันที"
          type="info"
          showIcon
        />
      </Form>
    </Modal>
  );
};

export default AddDefendantModal;
